export default __webpack_public_path__ + "66f91ee00af96300d448301fc7ae4549.png";